












































































































































import {Component, Vue, Watch} from 'vue-property-decorator';
import axios from 'axios';

@Component({
    components: {},
})
export default class CompositionSearch extends Vue {
    public loading = false;

    public el_SiO2 = '';
    public el_TiO2 = '';
    public el_Al2O3 = '';
    public el_FeO = '';
    public el_MgO = '';
    public el_CaO = '';
    public el_Na2O = '';
    public el_K2O = '';
    public el_P2O5 = '';
    public el_Cr2O3 = '';


    public pagination = {
        page: 1,
        rowsPerPage: 20,
        totalItems: 0,
        totalPages: 0,

        rowsPerPageItems: [10, 20, 50, 100,],
    };

    public error = false;
    public errorText = "";

    public items = [];
    public headers = [
        {
            text: 'Phase',
            sortable: true,
            value: 'phase',
        },
        {
            text: 'Sample',
            sortable: true,
            value: 'sample',
        },
        {
            text: 'SiO2',
            value: 'el_sio2',
        },
        {
            text: 'TiO2',
            value: 'el_tio2',
        },
        {
            text: 'Al2O3',
            value: 'el_al2O3',
        },
        {
            text: 'FeO',
            value: 'el_feo',
        },
        {
            text: 'Fe2O3',
            value: 'el_fe2o3',
        },
        {
            text: 'MnO',
            value: 'el_mno',
        },
        {
            text: 'MgO',
            value: 'el_mgo',
        },
        {
            text: 'CaO',
            value: 'el_cao',
        },
        {
            text: 'Na2O',
            value: 'el_na2o',
        },
        {
            text: 'K2O',
            value: 'el_k2o',
        },
        {
            text: 'P2O5',
            value: 'el_p2o5',
        },
        {
            text: 'Cr2O3',
            value: 'el_cr2o3',
        },
        {
            text: 'NiO',
            value: 'el_nio',
        },
        {
            text: 'CuO',
            value: 'el_cuo',
        },
    ];

    @Watch('pagination', {deep: true})
    public onPaginationHandler(val: any, oldVal: any) {
        if (val.page !== oldVal.page || val.rowsPerPage !== oldVal.rowsPerPage) {
            this.loadData();
        }
    }

    public searchQuery() {
        this.loadData();
    }

    public searchDownload() {
        this.exportData();
    }

    get isSearchEnable () {
        return this.buildQueryString().length > 0
    }

    // noinspection JSUnusedLocalSymbols
    private async created() {
    }

    private async loadData() {
        this.loading = true;
        this.error = false;

        try {
            const response = await axios.get('/search?composition=' + encodeURI(this.buildQueryString()) + '&page=' +
                (this.pagination.page - 1) + '&size=' + this.pagination.rowsPerPage);

            this.items = response.data.content;
            this.pagination.page = response.data.number + 1;
            this.pagination.rowsPerPage = response.data.size;
            this.pagination.totalItems = response.data.totalElements;
            this.pagination.totalPages = response.data.totalPages;
        } catch (e) {
            console.log(JSON.stringify(e));

            this.error = true;
            this.errorText = e.message + ', ' + e.config.url;
        }

        this.loading = false;
    }

    private async exportData() {
        this.loading = true;
        this.error = false;

        try {
            const response = await axios({
                url: '/export?composition=' + encodeURI(this.buildQueryString()) + '&page=0?size=100',
                method: 'GET',
                responseType: 'blob',
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'search_results.xlsx');
            document.body.appendChild(link);
            link.click();
        } catch (e) {
            console.log(JSON.stringify(e));

            this.error = true;
            this.errorText = e.message + ', ' + e.config.url;
        }

        this.loading = false;
    }

    private buildQueryString() {
        let compositionUri = [];
        if (this.el_SiO2 !== "") {
            compositionUri.push("SiO2~" + this.el_SiO2)
        }
        if (this.el_TiO2 !== "") {
            compositionUri.push("TiO2~" + this.el_TiO2)
        }
        if (this.el_Al2O3 !== "") {
            compositionUri.push("Al2O3~" + this.el_Al2O3)
        }
        if (this.el_FeO !== "") {
            compositionUri.push("FeO~" + this.el_FeO)
        }
        if (this.el_MgO !== "") {
            compositionUri.push("MgO~" + this.el_MgO)
        }
        if (this.el_CaO !== "") {
            compositionUri.push("CaO~" + this.el_CaO)
        }

        if (this.el_Na2O !== "") {
            compositionUri.push("Na2O~" + this.el_Na2O)
        }
        if (this.el_K2O !== "") {
            compositionUri.push("K2O~" + this.el_K2O)
        }
        if (this.el_P2O5 !== "") {
            compositionUri.push("P2O5~" + this.el_P2O5)
        }
        if (this.el_Cr2O3 !== "") {
            compositionUri.push("Cr2O3~" + this.el_Cr2O3)
        }

        return compositionUri.join(";")
    }
}
